import { DataTestId, TextKey } from '@mews-commander/enums';
import { Button, ButtonProps } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';

export const CheckInButton = ({ textKey, ...props }: ButtonProps & { textKey?: Mews.TextKey }) => (
    <Button {...props} data-test-id={DataTestId.CheckInButton} type="submit">
        <LocalizedText textKey={textKey ?? TextKey.CheckIn} />
    </Button>
);
